export class Margin {
	left: number;
	right: number;
	top: number;
	bottom: number;

	constructor(left?: number, top?: number, right?: number, bottom?: number) {
		this.left = left || 0;
		this.right = right || 0;
		this.top = top || 0;
		this.bottom = bottom || 0;
	}
}
